"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handlePopoverPosition = void 0;
var _popover = require("@reach/popover");
var handlePopoverPosition = function handlePopoverPosition(triggerRef, popoverRect) {
  var _triggerRef$current;
  var buttonRect = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getBoundingClientRect();
  /* istanbul ignore if */
  if (!buttonRect || !popoverRect) {
    return {};
  }
  var _getCollisions = (0, _popover.getCollisions)(buttonRect, popoverRect),
    directionUp = _getCollisions.directionUp,
    directionLeft = _getCollisions.directionLeft;
  return {
    left: directionLeft ? "".concat(buttonRect.left + window.pageXOffset, "px") : "".concat(buttonRect.right - popoverRect.width + window.pageXOffset, "px"),
    top: directionUp ? "".concat(buttonRect.top - popoverRect.height + window.pageYOffset, "px") : "".concat(buttonRect.top + buttonRect.height + window.pageYOffset, "px")
  };
};
exports.handlePopoverPosition = handlePopoverPosition;